import { __require as a } from "./toFinite.js";
var e, i;
function _() {
  if (i) return e;
  i = 1;
  var n = a();
  function o(u) {
    var r = n(u), t = r % 1;
    return r === r ? t ? r - t : r : 0;
  }
  return e = o, e;
}
export {
  _ as __require
};
